<form *ngIf="templateForm" [formGroup]="templateForm" class="content-card" (ngSubmit)="onSubmit(templateForm)">
  <mat-card class="wide-form-80-card">
    <mat-card-header>
      <mat-card-title>
        <h5>User email template</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="Template name" formControlName="name" required>
      </mat-form-field>

      <div style="margin-bottom: 20px;">
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 0" (click)="selectLanguage(0)">German</button>
        <button mat-raised-button color="primary" [disabled]="selectedLanguage === 1" (click)="selectLanguage(1)">English</button>
      </div>

      <div class="template-var-group">
        <button *ngFor="let cmd of commands" mat-raised-button class="template-var-item" color="primary" type="button"
          (click)="addText(cmd.name)">{{cmd.title}}</button>
      </div>

      <mat-form-field>
        <textarea rows="6" matInput placeholder="Message" [formControlName]="'message'+this.lang" #textareamessage required></textarea>
      </mat-form-field>

      <span *ngIf="templateForm?.controls['message'+lang]?.value?.length > 160" style="color: red;">
        ~ {{ templateForm?.controls['message'+lang]?.value?.length }}
      </span>
      <span *ngIf="templateForm?.controls['message'+lang]?.value?.length <= 160" style="color: green;">
        ~ {{ templateForm?.controls['message'+lang]?.value?.length }}
      </span>
      <span>
        &nbsp;/&nbsp; 160 &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      <div *ngIf="templateForm?.controls['message'+lang]?.value?.includes('*|')" style="margin-top: 15px;">
        <mat-icon style="color: red;">info</mat-icon><span class="aligned-with-icon" style="color:red;">The length of the message cannot be calculated correctly because placeholders are used</span>
      </div>

    </mat-card-content>
    <mat-card-actions align="end">

      <div>
        <a mat-raised-button color="accent" type="button" routerLink="../..">Cancel</a>
        <button mat-raised-button color="primary" type="submit" [disabled]="!templateForm.valid">Save</button>
      </div>
    </mat-card-actions>
  </mat-card>
</form>
